/**
 * @file Automatically generated by barrelsby.
 */

export * from './toolbar-button.component';
